import colorMod from 'color';

export default ({ color, typography, fontSize }) => ({
  legendContainer: {
    display: 'inline-block',
    width: '30%',
    fontSize: fontSize.small,
    fontFamily: typography.smallText,
    overflowY: 'scroll',
    height: 'auto',
    '@media print': {
      border: '1px solid lightgrey',
      display: 'block',
      overflowY: 'visible',
      width: '100%',
    },
  },
  legendItem: {
    borderBottom: `1px solid ${color.bodyText}`,
    width: '100%',
  },
  legendItemName: {
    borderBottom: `1px solid ${color.borderColor}`,
    padding: '12px 16px 8px 16px',
    overflow: 'hidden',
    textAlign: 'left',
  },
  tooltipContent: {
    maxWidth: 500,
    fontWeight: 'bold',
  },
  legendItemData: {
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    padding: '12px 16px 8px 16px',
    borderBottom: `1px solid ${color.borderColor}`,
    '&:hover': {
      backgroundColor: colorMod(color.primaryButtonBackground).alpha(0.08).string(),
      cursor: 'pointer',
    },
    '&.legendItemData__disable': {
      pointerEvents: 'none',
      backgroundColor: '#F0F0F0',
      color: '#A8A8A8',
    },
    '&:last-child': {
      border: 'none',
    },
  },
  itemName: {
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    fontWeight: 'bold',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '100%',
    direction: 'ltr',
  },
  legendItemDataValue: {
    float: 'right',
  },
});
